module.exports = __webpack_public_path__ + "static/img/school-banner.348b86b2.png";